<template>
<user-budgets-table></user-budgets-table>
</template>

<script>
import UserBudgetsTable from '../../_components/userBudgets/UserBudgetsTable'
import { segmentTrack } from '@/analytics/segment'
export default {
  name: 'UserBudgets',
  components: { UserBudgetsTable },
  computed: {
    userId () {
      return this.$route.params.id
    }

  },
  async created () {
    this.$store.dispatch('UsersStore/clearUserBudgets')
        let filters = {
      'user.id': this.userId,
      'budget.status.code': 'ACTIVE',
      'isMember': true
    }
    await this.$store.dispatch('UsersStore/fetchUserBudgets', { pagination: true, filters: filters })
    segmentTrack('User budgets opened', {
      member_active_budgets_count: this.$store.getters['UsersStore/userBudgetsTotalItems']
    })
  }
}
</script>

<style>

</style>
